import { toast } from 'react-toastify';
import { generateCreditAnalysisReportService } from './service';
import { CREDIT_ANALYSIS_FAILURE_MESSAGE } from './constants';
import { CreditAnalysisReportMeta, CreditAnalysisReportPayload } from './types';

/**
 * Asks underwriting to build the Credit Analysis workbook and returns the
 * Mnemosyne doc it produced, or null.
 *
 * Both failure paths toast the same message and return null rather than
 * throwing: the caller is a CTA whose only recovery is to stop its spinner, so
 * a rejected promise would give it nothing to do but re-swallow the error.
 */
export async function generateCreditAnalysisReport(payload: CreditAnalysisReportPayload): Promise<CreditAnalysisReportMeta | null> {
    try {
        const response = await generateCreditAnalysisReportService(payload);
        const data = response?.data?.data;
        if (data?.mnemosyneDocId) {
            return { mnemosyneDocId: data.mnemosyneDocId, fileName: data.fileName };
        }
        toast.error(CREDIT_ANALYSIS_FAILURE_MESSAGE);
        return null;
    } catch (err) {
        toast.error(CREDIT_ANALYSIS_FAILURE_MESSAGE);
        return null;
    }
}
